module.exports = __webpack_public_path__ + "img/home.589b377b.jpg";